<template>
  <div class="enquiry-list">
    <div class="md-layout enquiry-header">
      <div class="md-layout-item md-size-20 customer">Customer</div>
      <div class="md-layout-item md-size-10 heat">Potential</div>
      <div class="md-layout-item md-size-20 follow-up">Follow Up</div>
      <div class="md-layout-item md-size-20 follow-up">Manager</div>
      <div class="md-layout-item md-size-20 follow-up">Adventures</div>
      <div class="md-layout-item md-size-10 actions"></div>
    </div>
    <div v-for="enquiry in enquiries" :key="enquiry.id">
      <enquiry-list-item :enquiry="enquiry" @deleteEnquiry="deleteEnquiry" />
    </div>
  </div>
</template>

<script>
import confirm from "@/helpers/deleteConfirm";
import EnquiryListItem from "./EnquiryListItem.vue";

export default {
  props: ["enquiries"],

  components: {
    EnquiryListItem
  },

  methods: {
    deleteEnquiry(enquiry) {
      confirm.delete(null).then(resp => {
        if (resp.value) {
          this.$emit("deleteEnquiry", enquiry);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/md/_variables.scss";
.enquiry-header {
  border-bottom: 1px solid $brand-primary;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
